module.exports = __webpack_public_path__ + "media/recipes/127-372cc70d.png";